(function () {
  'use strict';

  angular.module('tf.retailer.Util')
      .constant('LookAndFeelType',{
        BrandMetrics: 'BrandMetrics',
        Analytics: 'Analytics'
      })
      .factory('LookAndFeel', LookAndFeel);

  // @ngInject
  function LookAndFeel($log, $injector, Nav, StandardReportPrivileges, LookAndFeelType, GaUtil) {

    var lookAndFeel = null;
    return {
      setToAnalytics: setToAnalytics,
      setToBrandMetrics: setToBrandMetrics,
      get: get,
      reset: reset,
      setLookAndFeelOnUserLogin: setLookAndFeelOnUserLogin,
      isAnalytics: isAnalytics,
      isBrandMetrics: isBrandMetrics
    };

    function set(currentLookAndFeel) {
      lookAndFeel = currentLookAndFeel;
    }

    function get() {
      return lookAndFeel;
    }

    function reset(){
      lookAndFeel = null;
    }

    function setLookAndFeelOnUserLogin(user){
      if(user){
        if(user && isAnalyticsUser(user)){
          setToAnalytics();
          GaUtil.setGaDimension('dimension2', LookAndFeelType.Analytics);
        }else {
          setToBrandMetrics();
          GaUtil.setGaDimension('dimension2', LookAndFeelType.BrandMetrics);
        }
      } else {
        $log.error("User needs to be logged in for setting the lookEndFeel")
      }
    }

    function isAnalyticsUser(user){
      return _.includes(user.privileges, "InsightsAnalyticsUser")
    }

    function isAnalytics(){
      return LookAndFeelType.Analytics === lookAndFeel;
    }

    function isBrandMetrics(){
      return LookAndFeelType.BrandMetrics === lookAndFeel;
    }

    function setToAnalytics(){
      set(LookAndFeelType.Analytics);
    }

    function setToBrandMetrics(){
      set(LookAndFeelType.BrandMetrics);
    }

  }

})();